import { type ReactElement } from 'react';
import { Form, useNavigation } from 'react-router';
import { Button, type ButtonVariant } from '@marketplace/ui';
import { type OnboardingFrom } from './onboarding.js';

/**
 * `W5-T01` §4.3 — the one control that sends a provider to Stripe, wherever it appears.
 *
 * A form, not a link: asking for an Account Link is a write (it can create the connected account),
 * so it is a `POST` to the payouts route's action, which redirects to Stripe. The action is named
 * explicitly, because this renders on the feed pages and on the refresh page, whose own routes have
 * no action. Disabled while the router is busy, so a second click cannot ask for a second link.
 */
export function ContinueWithStripe({
  locale,
  from,
  label,
  variant = 'primary',
  step = false,
}: {
  locale: string;
  from: OnboardingFrom;
  label: string;
  variant?: ButtonVariant;
  /** The registration step posts to itself, so a refused link is shown on the step. */
  step?: boolean;
}): ReactElement {
  const navigation = useNavigation();
  const action = `/${locale}/account/payouts${step ? '?step=registration' : ''}`;

  return (
    <Form method="post" action={action}>
      <input type="hidden" name="from" value={from} />
      <Button type="submit" variant={variant} isDisabled={navigation.state !== 'idle'}>
        {label}
      </Button>
    </Form>
  );
}
